module.exports = __webpack_public_path__ + "static/media/info_circle_red.c576d3a9.svg";